/* eslint-disable import/no-unused-modules */
import { createContext } from 'react';

export const PROJECTS_FILTERS_CONTEXTS_NAMES = {
  RESOURCE_ALLOCATION: 'RESOURCE_ALLOCATION',
  PROJECT_PROGRESSION: 'PROJECT_PROGRESSION',
  INVESTMENT_CARVING: 'INVESTMENT_CARVING'
};

const mapFiltersContextToModuleNames = {
  [PROJECTS_FILTERS_CONTEXTS_NAMES.RESOURCE_ALLOCATION]: 'Resource Allocation',
  [PROJECTS_FILTERS_CONTEXTS_NAMES.INVESTMENT_CARVING]: 'Investment Strategy',
  [PROJECTS_FILTERS_CONTEXTS_NAMES.PROJECT_PROGRESSION]: 'Forecasting'
};

export const FILTERS_PROVIDER_STORAGE_KEYS = {
  PERIOD: 'period',
  FILTERS: 'filters',
  SELECTED_FILTER_SET_ID: 'selectedFilterSetId'
};

export const FILTERS_PROVIDER_QS_KEYS = {
  FILTER_SET_ID: 'filter_set_id'
};

const createFiltersContext = name => {
  const Context = createContext();
  Context.name = name;
  Context.moduleName = mapFiltersContextToModuleNames[name];
  Context.storageKeys = {
    [FILTERS_PROVIDER_STORAGE_KEYS.PERIOD]: `${name}_period`,
    [FILTERS_PROVIDER_STORAGE_KEYS.FILTERS]: `${name}_filters`,
    [FILTERS_PROVIDER_STORAGE_KEYS.SELECTED_FILTER_SET_ID]: `${name}_selectedFilterSetId`
  };
  return Context;
};

export const ProjectProgressionFiltersContext = createFiltersContext(
  PROJECTS_FILTERS_CONTEXTS_NAMES.PROJECT_PROGRESSION
);

export const ForecastFiltersContext = ProjectProgressionFiltersContext;

export const ResourceAllocationFiltersContext = createFiltersContext(
  PROJECTS_FILTERS_CONTEXTS_NAMES.RESOURCE_ALLOCATION
);

export const InvestmentCarvingFiltersContext = createFiltersContext(
  PROJECTS_FILTERS_CONTEXTS_NAMES.INVESTMENT_CARVING
);
